
import type { SVGProps } from 'react';
const SvgDeparture = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#263E6A"
      d="M19.874 16.554H3.444q-.177 0-.31.213a.94.94 0 0 0-.134.51q0 .299.133.511.134.213.312.213h16.45q.2 0 .334-.213a.94.94 0 0 0 .134-.51.84.84 0 0 0-.156-.511q-.133-.213-.333-.213m.644-10.255L18.606 6l-3.601 1.617-6.892-1.213-1.2.447 4.602 2.298-3.846 1.723-2.557-.085-1.49.553 2.668 1.277 2.001-.32a20 20 0 0 0 2.023-.425q.956-.255 1.868-.596l5.557-2.063a8.8 8.8 0 0 0 1.645-.809 9.5 9.5 0 0 0 1.468-1.149.59.59 0 0 0 .11-.596.51.51 0 0 0-.444-.361"
    />
  </svg>
);
export default SvgDeparture;
